import { ChartValueData } from "@repo/core/components/chart/ReportCharts/types";

export const normalizeVisualizationDataValues = (
  chartValues: ChartValueData[]
) => {
  return chartValues.map((chartValueData) => ({
    x: chartValueData.label,
    y: chartValueData.value
  }));
};

export const normalizeLineDataValues = (lineValues: { value: number }[]) => {
  return lineValues.map((line, index) => ({ x: index + 1, y: line.value }));
};

export const getTickValues = (maxValue: number, numberOfGridLines: number) => {
  const tickValue = Math.ceil(maxValue / numberOfGridLines);
  return Array.from({ length: numberOfGridLines + 1 }, (_, index) => {
    return index * tickValue;
  });
};
